import {LOG_UTM, GET_COUNTRIES, SET_COUNTRIES} from "@/core/store/modules/generic/constants";
import api from "@/core/services/api/api.service";

export default {
    [GET_COUNTRIES](context) {
        return new Promise((resolve, reject) => {
            if (context.state.countries.length > 0) {
                resolve(true)
            }
            api.waiting('countries').get(`${process.env.VUE_APP_API_COMMON_URL}/countries`).then((response) => {
                if (response.data?.codes) {
                    let countries = response.data.codes.map(item => {
                        return {value: item.id, label: item.code, flag: item.flag}
                    })
                    context.commit(SET_COUNTRIES, countries)
                    resolve(true)
                } else {
                    reject(false)
                }

            }).catch(() => {
                reject(false)
            })
        })
    },
    [LOG_UTM](context) {
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams(window.location.search);
            if (params.has('utm_source')) {
                api.get(`${process.env.VUE_APP_API_COMMON_URL}/utm?` + params).then((response) => {
                    resolve(true)
                }).catch(() => {
                    reject(false)
                })
            } else {
                resolve(true)
            }
        })
    },
}